<template>
  <div class="wizzard__form">
    <slot name="start" />
    <component
      :is="asset.getFormName()"
      :focus-on-load="focusNameOnLoad"
      :instance="asset"
      label="Name"
      :placeholder="`Ex. ${placeholder}`"
    />
    <div class="wizzard-step-data__grid">
      <component
        v-bind="{ restrictions }"
        :is="asset.getFormType()"
        :focus-on-load="focusTypeOnLoad"
        :instance="asset"
        :readonly="restrictions?.length === 1"
        label="Type"
      />
      <component
        :is="asset.getFormCurrency()"
        :instance="asset"
        label="Currency"
        class="wizzard-step-data__currency"
      />
    </div>
    <div class="wizzard-step-data__grid">
      <component
        :is="transaction.getFormDate()"
        :instance="transaction"
        :label="dateLabel"
      />
      <slot name="amount">
        <component
          :is="transaction.getFormAmount2()"
          :label="amountLabel"
          :instance="transaction"
        />
      </slot>
    </div>
    <component
      :is="transaction.getFormDescription()"
      :instance="transaction"
      label="Description"
      placeholder="Optional"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'

import { AssetClass, TransactionClass } from '@types'

import { ASSET_FIELD } from '@/const'

type Props = {
  transaction: TransactionClass
  asset: AssetClass
}

const props = defineProps<Props>()

defineOptions({ inheritAttrs: false })

const assetRestrictions = inject<string[] | undefined>(
  'assetRestrictions',
  undefined,
)
const assetExcludes = inject<string[] | undefined>('assetExcludes', undefined)

const restrictions = computed(
  () =>
    assetRestrictions ||
    props.transaction.settings?.entries[0].asset?.includes?.filter(
      item => !assetExcludes || !assetExcludes?.includes(item),
    ),
)

const amountLabel = inject<string>('assetCostLabel', 'Cost')
const dateLabel = inject<string>('assetDateLabel', 'Date')

const placeholder = inject<string>('assetNamePlaceholder', 'Vintage 2023')

const focusNameOnLoad = computed(
  () => !props.asset.field(ASSET_FIELD.NAME).value,
)

const focusTypeOnLoad = computed(
  () => !focusNameOnLoad.value && !props.asset.field(ASSET_FIELD.TYPE).value,
)
</script>

<style>
.wizzard-step-data {
  &__grid {
    @apply grid grid-cols-1 sm:grid-cols-2 gap-4;
  }
  &__currency {
    @apply opacity-50 focus-within:opacity-100 transition-opacity duration-300;
  }
}
</style>
